import { Bootgrid } from "./bootgrid";
import { postValueChange as postValueChangeFunc } from "../wizard";

/**
 * Checks if the selected rows have changed compared to the previous selection
 */
export function selectedRowsChanged(this: Bootgrid): boolean {
    const selectedRowIds = getSelectedRowIds.call(this);
    if (this.previousSelectedRowIds === undefined) {
        this.previousSelectedRowIds = selectedRowIds;
        return false;
    }
    const valueChanged = !areArraysSame(this.previousSelectedRowIds, selectedRowIds);

    if (valueChanged) {
        this.previousSelectedRowIds = selectedRowIds;
    }
    return valueChanged;
}

/**
 * Checks if this bootgrid has postValueChange enabled
 */
export function hasPostValueChange(this: Bootgrid): boolean {
    return this.$bootgrid.attr("data-luscinia-bootgrid-postvaluechange") === "true";
}

/**
 * Triggers a postValueChange event to notify the server of data changes
 * Used in wizard scenarios to update dependent fields
 */
export function postValueChange(this: Bootgrid, additionalData: FormData = null) {
    let wizardForm = $(".block-wizard").find("form") as JQuery<HTMLFormElement>;
    let parameterName = $(".block-wizard").data("parameter");
    postValueChangeFunc.call(this.$bootgrid[0], wizardForm, parameterName, this.$bootgrid.attr("data-luscinia-field-name"), additionalData);
}

/**
 * Gets the currently selected row IDs
 */
function getSelectedRowIds(this: Bootgrid): string[] {
    return (this.$bootgrid as any).bootgrid("getSelectedRowIds")
}

/**
 * Compares two arrays for equality
 */
const areArraysSame = (arr1: string[], arr2: string[]): boolean => {
    const set1 = new Set(arr1);
    const set2 = new Set(arr2);
    return set1.size === set2.size && [...set1].every((item) => set2.has(item));
};
